import { supabase } from '@/core/database/supabase';
import { permissionEngine } from '@/core/permissions';

export const zoneNewService = {
  async getProjects(companyId: string) {
    if (!companyId) return [];
    const { data, error } = await supabase
      .from('projects')
      .select('id, name, code')
      .eq('company_id', companyId)
      .is('deleted_at', null)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data || [];
  },

  async getUnits(companyId: string) {
    if (!companyId) return [];
    
    const { data: allCategories, error } = await supabase
      .from('categories')
      .select('id, code, name, parent_id')
      .or(`company_id.eq.${companyId},company_id.is.null`)
      .order('name');

    if (error) throw error;

    const unitOptions: { value: string; label: string }[] = [];
    
    if (allCategories) {
      const unitParents = allCategories.filter(c => {
        const code = (c.code || '').toUpperCase();
        return code === 'OTHER-UNITS' || code === 'DON-VI-TINH';
      });

      if (unitParents.length > 0) {
        const parentIds = unitParents.map(p => p.id);
        const units = allCategories.filter(c => c.parent_id && parentIds.includes(c.parent_id));
        units.forEach(u => unitOptions.push({ value: String(u.id), label: String(u.name) }));
      }
    }

    return unitOptions;
  },

  async getParentZones(companyId: string) {
    if (!companyId) return [];
    const { data, error } = await supabase
      .from('project_zones')
      .select('id, zone_name')
      .eq('company_id', companyId)
      .is('parent_zone_id', null)
      .order('zone_name');
    if (error) throw error;
    return data || [];
  },

  async createZone(userId: string, data: any) {
    await permissionEngine.assert(userId, 'zones.create');

    const { data: result, error } = await supabase
      .from('project_zones')
      .insert({
        company_id: data.company_id,
        project_id: data.project_id,
        zone_name: data.zone_name,
        zone_code: data.zone_code,
        parent_zone_id: data.parent_zone_id,
        zone_type: data.zone_type,
        description: data.description,
        area_m2: data.area_m2,
        area_unit: data.area_unit,
        status_code: data.status_code,
        updated_at: new Date().toISOString(),
      })
      .select()
      .single();

    if (error) throw error;
    return result;
  }
};
